import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import { UilPlus } from "@iconscout/react-unicons";
import { useTranslation } from "react-i18next";
import Vimeo from "@u-wave/react-vimeo";

const GrayDiv = styled.div`
  background: #f2f7f7;
  padding: 18px 20px;
  @media only screen and (max-width: 768px) {
    padding: 30px 36px;
  }
  p {
    font-family: "IBM Plex Sans";
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    text-align: center;
    color: #1c3245;
    max-width: 928px;
    margin: 0px auto;
    @media only screen and (max-width: 768px) {
      text-align: left;
      font-size: 17px;
      line-height: 26px;
    }
  }
`;

const MainDiv = styled.div`
  background: #FFFFFF;
  font;
  h1 {
    font-weight: 700;
    text-align: center;
    color: #EAAC34;
    font-size: 40px;
    line-height: 130%;
    max-width: 446px;
    @media only screen and (max-width: 768px) {
      font-size: 30px;
    }
  }
  span {
    font-weight: 700;
  }
  #recursos-right {
    @media only screen and (max-width: 768px) {
      display: none;
    }
    background: #F2F7F7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 40px;
    overflow: hidden;
    width: 90%;
    max-width: 472px;
    margin: 0 auto;
    padding-bottom: 15px;
    p {
      background-color: #EAAC34;
      font-weight: 700;
      font-size: 24px;
      line-height: 31px;
      text-align: center;
      color: #FFFFFF;
      padding-top: 11px;
      padding-bottom: 7px;
    }
    li {
      text-align: left;
      a {
        text-decoration: underline;
        color: #353433;
      }
    }
    #ver-mas {
      font-weight: 400;
      font-size: 17px;
      line-height: 26px;
      text-decoration-line: underline;
      color: #EAAC34;
    }
  }
`;

const BlueButton = styled.button`
  background: #1379bc;
  border-radius: 100px;
  border: none;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  color: #ffffff;
  min-width: 213px;
  padding: 10px 25px 12px;
`;

const ForMe = styled(Row)`
  div img {
    max-width: 300px;
    width: 70%;
    @media only screen and (max-width: 992px) {
      margin-top: 20px;
      margin-bottom: 40px;
    }
  }
  #info {
    margin: 0 auto 86px;
    max-width: 384px;
    padding: 13px 13px 28px;
    background: #f2f7f7;
    border-radius: 20px 20px 0px 20px;
    position: relative;
    @media only screen and (max-width: 768px) {
      margin-bottom: 30px;
    }
    div {
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      justify-content: space-between;
      padding: 0 30px;
      width: 228px;
      img {
        width: 40px;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
      }
    }
    #link-copiado {
      transition: all ease 0.5s;
      padding: 3px 5px;
      background: #fff;
      box-shadow: 0px 4px 4px rgba(71, 74, 75, 0.15);
      position: absolute;
      right: 0px;
      bottom: -45px;
      display: none;
      z-index: 10;
    }
  }
  h1 {
    width: 75%;
    margin: 74px auto 37px;
    @media only screen and (max-width: 768px) {
      margin: 42px auto 21px;
    }
  }
  h2 {
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    text-align: center;
    color: #1c3245;
    margin: 0 auto 64px;
    max-width: 448px;
    @media only screen and (max-width: 768px) {
      font-size: 17px;
      line-height: 26px;
      margin-bottom: 31px;
    }
  }
  #col-img {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Doubts = styled(Row)`
  border: 2px solid #eaac34;
  border-radius: 40px;
  padding: 7px 53px 0px 0px;
  text-align: left;
  padding: 7px 53px 0px 0px;
  @media only screen and (max-width: 992px) {
    padding: 31px 29px 0px;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  div > #linea-labopat {
    position: relative;
  }
  div #linea-labopat {
    positiion: absolute;
    bottom: 0px;
    max-width: 267px;
    width: 100%;
  }
  #phone {
    width: 26px;
    position: absolute;
    top: 8px;
    left: -37px;
    @media only screen and (max-width: 992px) {
      top: -30px;
      left: 0px;
    }
  }
  h5 {
    margin-right: auto;
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    color: #1379bc;
  }
  h3 {
    font-weight: 700;
    font-size: 30px;
    line-height: 130%;
    letter-spacing: -0.02em;
    color: #eaac34;
    position: relative;
    @media only screen and (max-width: 992px) {
      margin-top: 30px;
    }
  }
  p {
    max-width: 320px;
    margin-right: auto;
  }
  button {
    margin-right: auto;
    @media only screen and (min-width: 992px) and (max-width: 1200px) {
      margin-bottom: 25px;
    }
    @media only screen and (max-width: 992px) {
      margin: 26px auto;
    }
  }
`;

const Terapies = styled(Row)`
  padding: 69px 0 81px;
  text-align: left;
  h1 {
    text-align: left;
    margin-top: 8px;
    margin-bottom: 16px;
  }
  h4 {
    font-weight: 700;
    font-size: 28px;
    width: 550px;
    line-height: 130%;
    letter-spacing: -0.02em;
    color: #1c3245;
    margin-bottom: 22px;
  }
  img {
    width: 100%;
    max-width: 430px;
    @media only screen and (max-width: 768px) {
      margin-top: 39px;
    }
  }
  p {
    max-width: 450px;
    margin-bottom: 58px;
    @media only screen and (max-width: 768px) {
      margin-bottom: 27px;
    }
  }
  div:nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Resources = styled.div`
  width: 100%;
  position: relative;
  background: #f2f7f7;
  padding-top: 132px;
  #fondo-img {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 84px;
  }
  h1 {
    margin: 0 auto 16px;
    @media only screen and (max-width: 768px) {
      margin: 0 auto 26px 28px;
      text-align: left;
    }
  }
  h6 {
    max-width: 576px;
    margin: 0 auto;
    margin-bottom: 49px;
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    text-align: center;
    color: #1c3245;
    @media only screen and (max-width: 768px) {
      text-align: left;
      margin-left: 36px;
      margin-right: 36px;
    }
  }
`;

const StyledAccordion = styled(Accordion)`
  width: 90%;
  max-width: 384px;
  margin: 0 auto;
  --bs-accordion-border-color: none;
  .accordion-header button {
    color: #353433;
    padding: 13px 25px 13px 20px;
    gap: 15px;
    height: 60.75px;
    background: #f2f7f7;
    border-radius: 20px 20px 0px 20px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    margin-bottom: 47px;
    .plus-icon {
      position: absolute;
      right: 25px;
      top: 18px;
    }
    p {
      margin-bottom: 0px;
    }
  }
  .accordion-button::after {
    display: none;
  }
  .accordion-button:focus {
    border-color: none;
    outline: 0;
    box-shadow: none;
  }
  .accordion-button:not(.collapsed) {
    color: #353433;
  }
  .accordion-body {
    padding-top: 0px;
    padding-left: 48px;
    padding-right: 56px;
    margin-bottom: 20px;
    background: #f2f7f7;
    color: #1379bc;
    text-align: left;
    @media only screen and (max-width: 768px) {
      padding-left: 31px;
      padding-right: 29px;
    }
  }
  .accordion-item {
    background: #f2f7f7;
  }
`;

export const Axiona = () => {
  const { t } = useTranslation("global");
  const copyToClipboard = () => {
    navigator.clipboard.writeText("axionagenetics.com");
    let text = document.getElementById("link-copiado");
    text.setAttribute("style", "display:block;");
    setTimeout(() => {
      text.setAttribute("style", "display:none !important;");
    }, 2000);
  };

  const [width, setWidth] = useState(window.innerWidth);
  let isMobile = width <= 768;

  return (
    <>
      <MainDiv>
        <Container>
          <ForMe>
            <Col
              xs={{ span: 12, order: 2 }}
              lg={{ span: 6, order: 1 }}
              id="col-img"
            >
              <img
                alt="doctor-paciente"
                src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fpacientes%2FblueGuys.png?alt=media&token=14644d9d-9cf1-422d-b7a7-a16a3b37f8b3"
              />
            </Col>
            <Col xs={{ span: 12, order: 1 }} lg={{ span: 6, order: 2 }}>
              <h1>{t("patients.for-me.title")}</h1>
              <h2>{t("patients.for-me.desc")}</h2>
              <div id="info">
                {t("patients.for-me.share")}
                <div>
                  <a
                    target="_blank"
                    href="https://wa.me/5215519694584?text=Conoce%20Axiona%20axionagenetics.com"
                    rel="noreferrer noopener"
                  >
                    <img
                      alt="whatsapp"
                      src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fpacientes%2Fwhats.png?alt=media&token=fbcbd2db-1587-4978-8d32-917efe640bac"
                    />
                  </a>
                  <a href="mailto: ?subject=Conoce%20Axiona&body=axionagenetics.com">
                    <img
                      alt="mail"
                      src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fpacientes%2Femail.png?alt=media&token=065416ad-1019-4c38-926c-b0955c41d82b"
                    />
                  </a>
                  <img
                    onClick={() => copyToClipboard()}
                    style={{ cursor: "pointer" }}
                    alt="copy-link"
                    src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fpacientes%2Fcopy%20link.png?alt=media&token=4809ebae-9ac9-486f-8cdb-d3d4d4c172a4"
                  />
                  <p id="link-copiado">{t("patients.for-me.link-copied")}</p>
                </div>
              </div>
            </Col>
          </ForMe>
        </Container>
      </MainDiv>

      <MainDiv>
        <GrayDiv>
          <p>{t("patients.desc")}</p>
        </GrayDiv>
      </MainDiv>
      <br />

      <MainDiv>
        <Container>
          <Doubts>
            <Col xs={{ span: 12, order: 3 }} lg={{ span: 3, order: 1 }}>
              <img
                id="linea-labopat"
                alt="linea-labopat"
                src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fpacientes%2FlineaAxiona.png?alt=media&token=33d7cd20-be52-4bd1-a00a-960edd53f2dc"
              />
            </Col>
            <Col xs={{ span: 12, order: 1 }} lg={{ span: 4, order: 2 }}>
              <h5>{t("patients.doubts.title")}</h5>
              <p>
                <span>{t("patients.doubts.desc-bold")}</span>{" "}
                {t("patients.doubts.desc")}
              </p>
            </Col>
            <Col xs={{ span: 12, order: 2 }} lg={{ span: 5, order: 3 }}>
              <h3>
                <img
                  id="phone"
                  alt="phone"
                  src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fpacientes%2Fphone.png?alt=media&token=5425d569-f710-4c43-84ec-872cf1eaf977"
                />
                {t("patients.doubts.contact")}
              </h3>
              <BlueButton>
                <a
                  target="_blank"
                  href="https://wa.me/5215519694584"
                  rel="noreferrer noopener"
                  style={{ color: "#fff" }}
                >
                  {t("patients.doubts.button")}
                </a>
              </BlueButton>
            </Col>
          </Doubts>

          <Terapies>
            <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }}>
              <img
                alt="pastillas-terapia"
                src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fpacientes%2Fpill.png?alt=media&token=8e1d912e-a00e-4106-8961-603b3b8a445d"
              />
            </Col>
            <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 2 }}>
              <h1>{t("patients.terapies.title")}</h1>
              <h4>{t("patients.terapies.subtitle")}</h4>
              <p>
                {t("patients.terapies.desc1")}{" "}
                {/*<span>{t("patients.terapies.desc-bold")}</span>{" "}
                {t("patients.terapies.desc2")}
                <br />
                <br />
                {t("patients.terapies.desc3")}*/}
                
              </p>

              <BlueButton onClick={() => (window.location.href = "/#contacto")}>
                {t("patients.terapies.button")}
              </BlueButton>
            </Col>
          </Terapies>
        </Container>

        <Resources>
          <img
            id="fondo-img"
            alt="fondo-img"
            src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fpacientes%2FbgForma.png?alt=media&token=b0a3ae54-ca7e-4fb3-a03e-5bd9d36e5074"
          />
          <Container>
            <h1>{t("patients.resources.title")}</h1>
            <h6>{t("patients.resources.subtitle")}</h6>
            <Row>
              <Col xs={12} lg={5}>
                <StyledAccordion defaultActiveKey="">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <p>
                        {t("patients.resources.accordions.acc1-header")}{" "}
                        <span>gen</span>?
                      </p>
                      <UilPlus
                        color="#EAAC34"
                        size={25}
                        className="plus-icon"
                      />
                    </Accordion.Header>
                    <Accordion.Body>
                      {t("patients.resources.accordions.acc1-body.one")}{" "}
                      <span>
                        {t("patients.resources.accordions.acc1-body.bold")}
                      </span>{" "}
                      {t("patients.resources.accordions.acc1-body.two")}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <p>
                        {t("patients.resources.accordions.acc2-header")}{" "}
                        <span>
                          {t("patients.resources.accordions.acc2-header-bold")}
                        </span>
                        ?
                      </p>
                      <UilPlus
                        color="#EAAC34"
                        size={25}
                        className="plus-icon"
                      />
                    </Accordion.Header>
                    <Accordion.Body>
                      {t("patients.resources.accordions.acc2-body.one")}{" "}
                      <span>
                        {t("patients.resources.accordions.acc2-body.bold")}
                      </span>{" "}
                      {t("patients.resources.accordions.acc2-body.two")}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <p>
                        {t("patients.resources.accordions.acc3-header")}
                        <span>
                          {t("patients.resources.accordions.acc3-header-bold")}
                        </span>
                        ?
                      </p>
                      <UilPlus
                        color="#EAAC34"
                        size={25}
                        className="plus-icon"
                      />
                    </Accordion.Header>
                    <Accordion.Body>
                      {t("patients.resources.accordions.acc3-body.one")}{" "}
                      <span>
                        {t("patients.resources.accordions.acc3-body.bold")}
                      </span>{" "}
                      {t("patients.resources.accordions.acc3-body.two")}
                    </Accordion.Body>
                  </Accordion.Item>
                </StyledAccordion>
              </Col>
              <Col xs={12} lg={7}>
                <div id="recursos-right">
                  <p>{t("patients.resources.downloadables.title")}</p>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        href="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FGlosario_axiona%20(2).pdf?alt=media&token=76385b4a-a471-42e4-a38f-b33b1992db69"
                        rel="noreferrer noopener"
                      >
                        {t("patients.resources.downloadables.link1")}
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fpdf%2FREPORTE%20AXIONA%20SOLID%20EJEMPLO.pdf?alt=media&token=2c64bb47-b69a-419d-bc22-f5006b88545d"
                        rel="noreferrer noopener"
                      >
                        {t("patients.resources.downloadables.link2")}
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fpdf%2FREPORTE%20DE%20RESULTADO%20AXIONA%20GENE%20EJEMPLO.pdf?alt=media&token=0b06859c-992b-4392-a82d-c55314303bac"
                        rel="noreferrer noopener"
                      >
                        {t("patients.resources.downloadables.link3")}
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fpdf%2FREPORTE%20EJEMPLO%20AXIONA%20HEM.pdf?alt=media&token=2dcdeb17-151f-4277-93e3-8726503cb7e0"
                        rel="noreferrer noopener"
                      >
                        {t("patients.resources.downloadables.link4")}
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fpdf%2FREPORTE%20AXIONA%20LIQUID%20EJEMPLO.pdf?alt=media&token=21f6129e-a8e0-44e0-92da-f8d9a8c09aa2"
                        rel="noreferrer noopener"
                      >
                        {t("patients.resources.downloadables.link5")}
                      </a>
                    </li>
                  </ul>
                  {/* <a id="ver-mas" href="#">Ver más</a> */}
                </div>
              </Col>
            </Row>
          </Container>
        </Resources>
      </MainDiv>
    </>
  );
};
